import React, { useState, useEffect } from 'react';
import { formatPrice } from 'common/src/utils/functions';
import { metrics__get_gender_stats } from 'common/src/api/metrics';

interface GenderStats {
  month_date: string;
  female_task_count: number;
  female_avg_ticket: number;
  male_task_count: number;
  male_avg_ticket: number;
  total_task_count: number;
  total_avg_ticket: number;
}

const GenderStatsTable: React.FC = () => {
  const [stats, setStats] = useState<GenderStats[]>([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    // Set initial date range to last 30 days
    const today = new Date();
    const endDate = new Date(today);
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - 29); // 30 days ago (including today)

    setStartDate(startDate.toISOString().split('T')[0]);
    setEndDate(endDate.toISOString().split('T')[0]);
  }, []);

  const fetchStats = async () => {
    if (!startDate || !endDate) return;

    try {
      const { data, error } = await metrics__get_gender_stats(startDate, endDate);
      if (error) throw error;
      setStats(data);
    } catch (error) {
      console.error('Error fetching gender stats:', error);
    }
  };

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
    });
  };

  return (
    <div>
      <div className="mb-4">
        <label className="mr-2">Fecha de inicio:</label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="border p-1 mr-4"
        />
        <label className="mr-2">Fecha de fin:</label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="border p-1"
        />
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="py-2 px-4 border">Mes</th>
              <th className="py-2 px-4 border text-center" colSpan={2}>
                Mujeres
              </th>
              <th className="py-2 px-4 border text-center" colSpan={2}>
                Hombres
              </th>
              <th className="py-2 px-4 border text-center" colSpan={2}>
                Total
              </th>
            </tr>
            <tr className="bg-gray-50">
              <th className="py-2 px-4 border"></th>
              <th className="py-2 px-4 border">Cantidad</th>
              <th className="py-2 px-4 border">Promedio</th>
              <th className="py-2 px-4 border">Cantidad</th>
              <th className="py-2 px-4 border">Promedio</th>
              <th className="py-2 px-4 border">Cantidad</th>
              <th className="py-2 px-4 border">Promedio</th>
            </tr>
          </thead>
          <tbody>
            {stats.map((stat, index) => (
              <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                <td className="py-2 px-4 border">{formatDate(stat.month_date)}</td>
                <td className="py-2 px-4 border text-right">{stat.female_task_count}</td>
                <td className="py-2 px-4 border text-right">
                  {formatPrice(stat.female_avg_ticket)}
                </td>
                <td className="py-2 px-4 border text-right">{stat.male_task_count}</td>
                <td className="py-2 px-4 border text-right">{formatPrice(stat.male_avg_ticket)}</td>
                <td className="py-2 px-4 border text-right">{stat.total_task_count}</td>
                <td className="py-2 px-4 border text-right">
                  {formatPrice(stat.total_avg_ticket)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GenderStatsTable;
